<template>
<div class="withdraw-card">
  <div class="card-top">
    <div class="top-left">
      <img
        class="icon-img"
        :src="withdrawPayInfo.logoUrl"
        alt=""
      >
      <span class="name">{{withdrawPayInfo.channelName}}</span>
    </div>
    <span
      class="top-right">
      <el-button
        size="small"
        @click="withdrawHandle"
      >{{$t('User.out')}}</el-button>
    </span>
  </div>
  <div class="bottom-line">
    <p
      v-for="(item,index) in withdrawPayInfo.descs"
      :key="index"
    >{{item}}</p>
  </div>
</div>
</template>

<script>
export default {
  name: "withdrawCard",
  props: {
    withdrawPayInfo: {
      type: Object,
      default(){
        let _this = this;
        return {
          // type: 1,
          type: 3,
          logoUrl: '',
          channelName: '',
          descs: [
          ]
        }
      }
    },
  },
  methods: {
     withdrawHandle() {
       /*this.$store.commit('withdrawDefaultType',this.withdrawPayInfo.type);
       this.$store.commit('setWithdrawDefaultPageTitle',title);*/
       this.$router.push({name: 'withdrawDetail',params:{payTypeId: this.withdrawPayInfo.payTypeId}},
         );
    }
  },
}
</script>

<style lang="scss" scoped>
// 出金渠道
.withdraw-card {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  .card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .icon-tips {
      color: #D85E5F;
    }
    .icon-img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
    .name {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .bottom-line {
    padding-left: 34px;
    padding-top: 15px;
    color: #6E6B7B;
  }
}
</style>
